<template>
    <div class="forex-index">
        <page-navigate></page-navigate>
        <div class="forex-wrapper cn">
            <forexMenu :linkname="article.category_route" />
            <div class="forex-wrapper-body">
                <div class="forex-inner-wrapper">
                    <div class="forex-inner-wrapper-left">
                        <div class="breadcrumb-box">
                            <div class="breadcrumb-link-item">
                                <a href="/jinrong/" class="breadcrumb-link">交易学院</a>
                            </div>
                            <div class="breadcrumb-link-item">
                                <a :href="'/jinrong/' + article.category_route + '/'" class="breadcrumb-link">{{
                                    article.category_name }}</a>
                            </div>

                            <div class="breadcrumb-link-item">
                                <span class="breadcrumb-link">{{ article.post_title }}</span>
                            </div>
                        </div>

                        <section class="section1">
                            <div>
                                <h1 class="">{{ article.post_title }}</h1>

                                <p class="publish-time">
                                    <span>
                                        发布日期: {{ formateTime(article.published_time) }}
                                    </span>
                                    <br class="mobile" />
                                    <!-- <span v-if="article.update_time">
                                        更新日期: {{ formateTime(article.update_time) }}
                                    </span> -->
                                </p>
                            </div>

                            <div class="detail-flex-box">
                                <div class="html-inner">
                                    <div v-html="article.post_content"></div>
                                </div>
                                <div>
                                    <swiper ref="swiperBasic" :options="swiperBasicOptions"
                                        class="right-info-link-list-mobile-wrapper">
                                        <swiper-slide>
                                            <a :href="'https://client.myebc.co/signup?bid=5s71xp&utm_source=Withdrawals&utm_content=article-zh-cn-' + id"
                                                class="right-info-link" rel="nofollow" target="_blank">
                                                <img class="right-info-link-img"
                                                    src="../../assets/image/forex/info/m cn 1.gif" alt="" />
                                            </a>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <a :href="'/tradingproduct?index=2&utm_source=GlobalMarkets&utm_content=article-zh-cn-' + id"
                                                class="right-info-link" rel="nofollow" target="_blank">
                                                <img class="right-info-link-img"
                                                    src="../../assets/image/forex/info/m cn 2.gif" alt="" />
                                            </a>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <a :href="'https://client.myebc.co/signup?bid=5s71xp&utm_source=bullandbearbanner&utm_content=article-zh-cn-' + id"
                                                rel="nofollow" target="_blank" class="right-info-link">
                                                <img class="right-info-img" src="../../assets/image/forex/info/m.gif"
                                                    alt="" />
                                            </a>
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>
                        </section>
                        <div class="forex-inner-wrapper-left-footer">
                            <div class="other-article">

                                <div v-if="prev_article" class="other-article-item">
                                    <div class="other-article-item-label">上一篇：</div>
                                    <a :href="prev_article.url.replace('/zh-cn','')" class="other-article-item-link">{{ prev_article.title
                                    }}</a>
                                </div>

                                <div v-if="next_article" class="other-article-item">
                                    <div class="other-article-item-label">下一篇：</div>
                                    <a :href="next_article.url.replace('/zh-cn','')" class="other-article-item-link">{{ next_article.title
                                    }}</a>
                                </div>

                            </div>
                            <forex-banner></forex-banner>


                        </div>
                    </div>
                    <div class="forex-inner-wrapper-right">
                        <div class="dictionary-list-box" v-if="related_dictionaries && related_dictionaries.length">
                            <div class="forex-inner-wrapper-right-title">相关词典</div>
                            <div class="related-dictionary-list">
                                <a :href="item.url.replace('/zh-cn', '')" class="related-dictionary-item"
                                    v-for="(item, index) in related_dictionaries" :key="index">
                                    {{ item.post_title }}
                                </a>
                            </div>
                        </div>
                        <swiper ref="swiperBasic" :options="swiperBasicPCOptions" class="right-info-link-list-wrapper">

                            <swiper-slide>
                                <a :href="'https://client.myebc.co/signup?bid=5s71xp&utm_source=Withdrawals&utm_content=article-zh-cn-' + id"
                                    class="right-info-link" rel="nofollow" target="_blank">
                                    <img class="right-info-link-img" src="../../assets/image/forex/info/pc-cn-3.gif"
                                        alt="" />
                                </a>
                            </swiper-slide>
                            <swiper-slide>
                                <a :href="'/tradingproduct?index=2&utm_source=GlobalMarkets&utm_content=article-zh-cn-' + id"
                                    class="right-info-link" rel="nofollow" target="_blank">
                                    <img class="right-info-link-img" src="../../assets/image/forex/info/pc-cn-4.gif"
                                        alt="" />
                                </a>
                            </swiper-slide>
                        </swiper>
                        <div v-if="related&&related.list&&related.list.length" class="article-list-box">
                            <div class="forex-inner-wrapper-right-title">
                                {{ related.title }}
                            </div>
                            <div class="article-list">
                                <div class="article-item" v-for="(item, index) in related.list" :key="index">
                                    <div>
                                        <a :href="item.url.replace('/zh-cn','')" class="article-item-title">
                                            {{ item.post_title }}
                                        </a>
                                        <div class="article-item-publish-time">
                                            {{ item.published_time }}
                                        </div>
                                    </div>
                                    <img class="article-item-img mobile"
                                    :src="item.thumbnail" alt="item.post_title" />
                                </div>
                            </div>
                        </div>

                        <div class="reading-list-box" v-if="recommended&&recommended.list&&recommended.list.length">
                            <div class="forex-inner-wrapper-right-title">
                                {{ recommended.title }}
                            </div>
                            <div class="reading-list">
                                <div class="reading-item" v-for="(item, index) in recommended.list" :key="index">
                                    <a :href="item.url.replace('/zh-cn','')">
                                        <img class="reading-item-img pc" :src="item.thumbnail" :alt="item.post_title" />
                                    </a>
                                    <div>
                                        <a :href="item.url.replace('/zh-cn','')" class="reading-item-title">
                                            {{ item.post_title }}
                                        </a>
                                        <div class="reading-item-publish-time">
                                            {{ item.published_time }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-info-box-tag">
                            <a :href="'https://client.myebc.co/signup?bid=5s71xp&utm_source=bullandbearbanner&utm_content=article-zh-cn-' + id"
                                rel="nofollow" target="_blank" class="right-info-box">
                                <img class="right-info-img" src="../../assets/image/forex/info/pc.gif" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <page-footer></page-footer>
    </div>
</template>
<script>
    import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getAcademyDetail } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import forexBanner from "../../components/forex-banner/forex-banner.vue";

export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide,
        forexBanner
    },
    data() {
        return {
            id: "",
            article: {
                category_id: "",
                article: '',
                id: "",
                post_content: "", post_excerpt: "", post_hits: "", post_source: "", post_title: "",
                published_time: "",
                update_time: "",
                thumbnail: "",
            },
            next_article: {
                id: "",
                title: "",
                url: "",
            },
            prev_article: {
                id: "",
                title: "",
                url: "",
            },
            related: {
                title: "",
                list: []
            },
            recommended: {
                title: "",
                list: []
            },
            related_dictionaries: [],
            swiperBasicOptions: {
                // 设置每页显示一张图片
                slidesPerView: 1,
                // 开启循环模式
                loop: true,
                spaceBetween: 20,
                // 自动播放设置
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false, // 用户操作后不关闭自动播放
                },
            },
            swiperBasicPCOptions: {
                // 设置每页显示一张图片
                slidesPerView: 1,
                // 开启循环模式
                loop: true,
                spaceBetween: 20,
                // 自动播放设置
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false, // 用户操作后不关闭自动播放
                },
            }
        }
    },
    created() {
        let id = this.$route.params.id.replace(".html", "");
        this.id = id

        getAcademyDetail(id).then((response) => {
            console.log("getAcademyDetail", response)
            if (response.status && response.status == 200) {
                console.log("getAcademyDetail article", response.data.data.article)
                this.article = response.data.data.article;
                this.next_article = response.data.data.next_article;
                this.prev_article = response.data.data.prev_article;
                this.related = response.data.data.related;
                this.recommended = response.data.data.recommended;
                this.related_dictionaries = response.data.data.related_dictionaries;
            }

        }).catch(() => { })
    },
    mounted() {

    },
    methods:{
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    }
}
</script>

<style>
body {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.html-inner {
    position: relative;
    overflow: hidden;
    font-size: 14rem;
    line-height: normal;
    padding-top: 36rem;
}

.forex-author a,
.html-inner a {
    color: #a52933;
}

.forex-author a:hover,
.html-inner a:hover {
    color: #7d0b14;
}

.html-inner p,
.html-inner span,
.html-inner div {
    flex-shrink: 0;
}

.html-inner p {
    font-size: 16rem;
    line-height: 28rem;
    color: #000;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    /* text-align: start !important; */
}

.html-inner span {
    font-size: 16rem;
    color: #000;
    line-height: 28rem;
    word-wrap: break-word;
    /* 允许长单词或 URL 换行 */
    word-break: break-word;
    /* 兼容性写法，注意：标准是 break-all 或 normal */
    white-space: normal;
    /* 允许空白符换行（关键） */
    overflow-wrap: break-word;
    /* 推荐替代 word-wrap */
    max-width: 100%;
}

.html-inner img {
    width: 100% !important;
    height: auto !important;
    margin: 20rem 0 12rem;
}

.html-inner strong {
    font-weight: 600 !important;
}


.html-inner ul {
    list-style-type: disc;
    /* 默认无序列表样式 */
    margin: 0.2em 0 0.5em;
    padding-left: 30px;
    /* 恢复默认缩进 */
    max-width: 100% !important;
}

.ar .html-inner ul {
    padding-left: 0;
    padding-right: 30px;
}

.html-inner ol {
    list-style-type: decimal;
    /* 默认有序列表样式 */
    margin: 0.2em 0 0.5em;
    padding-left: 30px;
    /* 恢复默认缩进 */
}

.ar .html-inner ol {
    padding-left: 0;
    padding-right: 30px;
}

/* 可选：防止 li 被全局样式干扰 */
.html-inner ul li,
.html-inner ol li {
    list-style: inherit;
    /* 继承父级 ul/ol 的 list-style */
}

.html-inner table {
    border-collapse: collapse !important;
    width: 100% !important;
    caption-side: top !important;
    margin: 10px auto !important;
}

.html-inner th,
.html-inner td {
    border: 1px solid #ddd !important;
    padding: 8px !important;
    text-align: left !important;
}

.html-inner th {
    background-color: #f2f2f2;
}

.html-inner caption {
    font-weight: bold;
    font-size: 20rem;
    margin-bottom: 20rem;
    text-align: center;
}

.forex-wrapper .html-inner h2 {
    font-size: 21rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.6;
    padding: 0;
    margin-bottom: 10rem;
}

.forex-wrapper .html-inner h3 {
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.6;
    padding: 0;
    margin-bottom: 6rem;
}

@media (max-width: 996px) {
    
    .html-inner {
        overflow: auto;
        font-size: 30rem;
        order: 2;
    }

    .html-inner img {
        width: 100% !important;
        height: auto !important;
    }

    .html-inner span {
        font-size: 32rem;
        line-height: 52rem;
    }

    .html-inner p {
        font-size: 32rem;
        text-align: left;
        line-height: 52rem;
    }

    /* .html-inner ul li::before {
    line-height: 44rem;
    left: 5px;
  }
  .ar .html-inner ul li::before {
    left: unset;
    right: 5px;
  } */
    .html-inner h1,
    .html-inner h2,
    .html-inner h3,
    .html-inner h4,
    .html-inner h5,
    .html-inner h6,
    .html-inner h7 {
        text-align: left !important;
    }

    .html-inner {
        padding-top: 0px;
    }

    .html-inner caption {
        font-size: 40rem;
        margin-bottom: 40rem;
    }

    .forex-wrapper .html-inner h2 {
        font-size: 40rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 8rem;
    }

    .forex-wrapper .html-inner h3 {
        font-size: 36rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 0;
    }
}
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.fixed-box {
    position: fixed;
    top: 100px;
    /* 距离顶部100像素 */
    width: 254rem;
    /* 根据需要可能还需要设置其他属性，比如宽度等 */
}



.section1 {
    margin-top: 40rem;
}

.forex-author-box {
    margin-top: 10rem;
    display: flex;
    gap: 20rem;
}

.forex-author {
    color: #000;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.publish-time {
    margin-top: 10rem;
    color: #b2afad;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.expert-banner-box {
    margin-top: 48rem;
}

.expert-banner-img {
    width: 100%;
    height: auto;
}


.right-info-box {
    display: block;
}

.right-info-img {
    width: 100%;
    height: auto;
}

.right-info-link-list-wrapper {
    width: 254rem;
}

.right-info-link {}

.right-info-link-img {
    border-radius: 8rem;
    overflow: hidden;
    width: 100%;
}

.right-info-link-list-mobile-wrapper {
    display: none;
}

@media (max-width: 996px) {
    .detail-flex-box {
        position: relative;
        display: inline-flex;
        flex-direction: column;
        width: 690rem;
    }

    .right-info-link-list-mobile-wrapper {
        display: block;
        margin-top: 0;
        margin-bottom: 32rem;
        order: 1;
    }

    .right-info-link-list-wrapper {
        display: none;
    }

    .right-info-link-img {
        border-radius: 16rem;
    }

    .right-info-box {
        display: none;
    }



    .section1 {
        margin-top: 10rem;
    }

    .expert-banner-box {
        margin-top: 80rem;
    }

    .forex-author {
        font-size: 28rem;
    }

    .publish-time {
        font-size: 28rem;
        margin-bottom: 32rem;
    }

    .video-list-box {
        display: none;
    }

    .article-item {
        display: none;
    }

    .article-item:nth-child(-n + 2) {
        display: flex;
    }

    .reading-item {
        display: none;
    }

    .reading-item:nth-child(-n + 2) {
        display: flex;
    }

}
</style>